import React from 'react';
import VersionList from '../VersionList';
import VersionListSearchBox from '../../../version/list/VersionListSearchBox';

const VersionListWrap = (props) => {
  const { versionList, getList, setData } = props;

  return (
    <div className="version-list-wrap">
      {/*버전 검색 박스*/}
      <VersionListSearchBox
        getList={getList}
        setData={(data) => {
          setData({
            path: ['versionList', 'searchData', ...data.path],
            value: data.value,
          });
        }}
        searchData={versionList.searchData}
      />

      {/*버전 전체 리스트*/}
      <VersionList versionList={versionList} getList={getList} />
    </div>
  );
};

export default VersionListWrap;
